import CustomComponent from '../CustomComponent';
import { isMobileDevice, isIOS, isAndroid } from '../../utils/deviceDetection';

export class PromotionalComponent extends CustomComponent {
	static key = 'lta-promotional-component';

	static get observedAttributes() {
		return [
			'size',
			'title',
			'subtitle',
			'background-type',
			'background-color',
			'background-image',
			'by-line-text',
			'default-button-link',
			'default-button-type',
			'default-button-text',
			'app-store-button-link',
			'play-store-button-link',
			'feature-img-src',
			'classes'
		];
	}

	render() {
		const {
			size = '',
			title = '',
			subtitle = '',
			backgroundType = '',
			backgroundColor = '',
			backgroundImage = '',
			byLineText = '',
			defaultButtonLink = '',
			defaultButtonType = '',
			defaultButtonText = 'Download the app',
			appStoreButtonLink = '',
			playStoreButtonLink = '',
			featureImgSrc = '',
			classes = ''
		} = this.props;

		const isFullBleed = size === 'full-bleed';

		const backgroundStyle =
			backgroundType === 'image' && 
                backgroundImage
                    ? `background-image: url(${backgroundImage}); background-size: cover; background-position: center; ${!isFullBleed ? 'border-radius: 6px' : ''};`
                    : backgroundType === 'color' &&
                backgroundColor
                    ? `background-color: ${backgroundColor}; color: #fff;`
                    : '';

		const renderButtons = () => {
			let buttons = '';
			const isDesktop = typeof navigator !== 'undefined' && !isMobileDevice();
			const isMobileOrTablet = typeof navigator !== 'undefined' && isMobileDevice();

			if (isDesktop) {
				// Desktop: show default button only
				if (defaultButtonType === 'link') {
						buttons += `
							<a href="${defaultButtonLink}" class="lta-btn lta-btn--lg lta-btn--${defaultButtonType} u-mx-3 md:u-mx-0 u-w-100 u-text-white">
								<div class="lta-promotional-component__action-info u-body1 u-text-white">${defaultButtonText}</div>
							</a>
						`;					
				} else {
					buttons += `
						<a href="${defaultButtonLink}" class="lta-btn lta-btn--lg lta-btn--${defaultButtonType} u-mx-3 md:u-mx-0 u-w-100">${defaultButtonText}</a>
					`;
				}
			} else if (isMobileOrTablet) {
				// Mobile/Tablet: show OS-specific store button
				if (isIOS() && appStoreButtonLink) {
					buttons += `
						<a class="lta-promotional-component__app-store-button-wrapper" href="${appStoreButtonLink}" target="_blank" rel="noopener">
							<img
								class="lta-promotional-component__app-button"
								src="/static/images/app-store.svg"
								alt="Download on the App Store"
							/>
						</a>
					`;
				} else if (isAndroid() && playStoreButtonLink) {
					buttons += `
						<a class="lta-promotional-component__play-store-button-wrapper" href="${playStoreButtonLink}" target="_blank" rel="noopener">
							<img
								class="lta-promotional-component__app-button"
								src="/static/images/play-store.svg"
								alt="Get it on Google Play"
							/>
						</a>
					`;
				} else if (defaultButtonLink) {
					// Fallback for other mobile OS or missing store link
					buttons += `
						<a href="${defaultButtonLink}" class="lta-btn lta-btn--lg lta-btn--${defaultButtonType} u-mx-3 md:u-mx-0 u-w-100">Download the app</a>
					`;
				}
			} else {
				// SSR or unknown: show default button if present
				if (defaultButtonLink) {
					buttons += `
						<a href="${defaultButtonLink}" class="lta-btn lta-btn--lg lta-btn--${defaultButtonType} u-mx-3 md:u-mx-0 u-w-100">Download the app</a>
					`;
				}
			}

			return buttons;
		};

		return `
            <div 
                class="${isFullBleed ? 'lta-promotional-component--full u-pb-0 md:u-pb-3' : 'l-grid u-pb-0 md:u-pb-3'}" 
            >
                <div 
                    class="lta-promotional-component ${classes}" 
                    style="${backgroundStyle}"
                >
                    <div class="lta-promotional-component__wrapper">
                        <div class="lta-promotional-component__content-wrapper">
                            <div class="lta-promotional-component__heading-wrapper">
                                <div class="lta-promotional-component__title u-herotitle2 u-text-white">${title}</div>
                                <p class="lta-promotional-component__sub-title u-hero-heading-3 u-text-white">${subtitle}</p>
                            </div>
                            <div class="lta-promotional-component__action-wrapper sm:u-hidden xl:u-flex">
                                <div class="lta-promotional-component__action-info u-body1 u-text-white">${byLineText}</div>
                                <div class="lta-promotional-component__app-buttons-container">
                                    ${renderButtons()}
                                </div>
                            </div>
                        </div>
                        ${featureImgSrc
                            ? `<div class="lta-promotional-component__image-wrapper">
                                    <div class="lta-promotional-component__inner-image-wrapper">
                                        <img
                                            class=${isFullBleed ? `lta-promotional-component__full-width-image` : "lta-promotional-component__normal-image"}
                                            src="${featureImgSrc}"
                                            alt="Phone Mockup"
                                        />
                                    </div>
                                </div>
                            `
                            : ''
                        }
                    </div>
                </div>
            </div>

            <div class="lta-promotional-component__action-wrapper xl:u-hidden xl:my-2">
                <div class="lta-promotional-component__action-info u-text-center">${byLineText}</div>
                <div class="lta-promotional-component__app-buttons-container">
                    ${renderButtons()}
                </div>
            </div>
            
		`;
	}
}

export default PromotionalComponent;
